jQuery(function($){  

  $('ul.tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $(this).parents('.product-tabs').find('ul.tabs li').removeClass('active');
    $(this).parents('.product-tabs').find('.tab-content').removeClass('active');

    $(this).addClass('active');
    $(this).parents('.product-tabs').find("#"+tab_id).addClass('active');
  });
  
  //Quantity selector
  $(document).on('click', '.qty', function(){
    var $qtyEl = $(this).siblings('.quantity');
    var value = parseInt($qtyEl.val());
    if($(this).hasClass('qty-plus')){
      value += 1;
      $qtyEl.val(value);
    } else if($(this).hasClass('qty-minus')){
      if(value > 1){
      value -= 1;
      $qtyEl.val(value);
      }
    }
    if($qtyEl.hasClass('cart-item-qty')){
      $qtyEl.trigger('change');
    }
  });
  
  //Review scrolling section 
  $('.scroll-trigger a[href^="#"]').on('click', function (e) {
    e.preventDefault();

    var target = this.hash;
    var $target = $(target);

    $('html, body').animate({
      'scrollTop': $target.offset().top - 100
    }, 1000, 'swing');
  });
  
  
  
  
  
  
  
  
  //setup before functions
  var typingTimer;                //timer identifier
  var doneTypingInterval = 2000;  //time in ms
  
  var $homeinput = $('#search.homepage');

  //on keyup, start the countdown
  $homeinput.on('keyup', function () {
    clearTimeout(typingTimer);
    $(".display-results.homepage").html("");
    $(".display-results.homepage").addClass("searching");
    typingTimer = setTimeout(doneTypingHome, doneTypingInterval);
  });

  //on keydown, clear the countdown 
  $homeinput.on('keydown', function () {
    clearTimeout(typingTimer);
  });

  //user is "finished typing," do something
  function doneTypingHome () {
   
    var searchstring = $('#search.homepage').val();
    
       
       if (searchstring == "") {
           $(".display-results.homepage").removeClass("searching").html("").hide();
       } else {
        

           $.ajax({

              type: "POST",
              url: "https://filters.batteryworld.ie/search/search.php",
              data: { searchstring: searchstring },

               success: function(html) {
                   $(".display-results.homepage").removeClass("searching").html(html).show();
               }

           });

       }
    
  }
  
  
  
  
  
  
  var $headerinput = $('#search.header');

  //on keyup, start the countdown
  $headerinput.on('keyup', function () {
    clearTimeout(typingTimer);
    $(".display-results.header").html("");
    $(".display-results.header").addClass("searching");
    typingTimer = setTimeout(doneTypingHeader, doneTypingInterval);
  });

  //on keydown, clear the countdown 
  $headerinput.on('keydown', function () {
    clearTimeout(typingTimer);
  });

  //user is "finished typing," do something
  function doneTypingHeader () {
   
    var searchstring = $('#search.header').val();

       $(".display-results.header").html("");
       $(".display-results.header").addClass("searching");

       if (searchstring == "") {
           $(".display-results.header").removeClass("searching").html("").hide();
       } else {

           $.ajax({

              type: "POST",
              url: "https://filters.batteryworld.ie/search/search.php",
              data: { searchstring: searchstring },

               success: function(html) {
                   $(".display-results.header").removeClass("searching").html(html).show();
               }

           });

       }
    
  }


  
  
    
});



   
